var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommunityStandpost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 50,
    viewBox: "0 0 44 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2679_772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.0118 21.6787C43.0118 28.0849 41.416 32.3933 35.1481 38.1504C35.0308 38.2599 21.838 49.4856 21.838 49.4856C21.838 49.4856 8.58982 38.0696 8.47247 37.9601C3.67948 33.7455 0.671875 28.0849 0.671875 21.6787C0.671875 9.98505 10.152 0.512695 21.838 0.512695C33.5317 0.512695 43.0118 9.98505 43.0118 21.6787Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9177 38.3818C31.2298 38.3818 38.7788 30.8329 38.7788 21.5207C38.7788 12.2086 31.2298 4.65967 21.9177 4.65967C12.6056 4.65967 5.05664 12.2086 5.05664 21.5207C5.05664 30.8329 12.6056 38.3818 21.9177 38.3818Z",
    fill: "#A2DB67",
    stroke: "#55990E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.433 19.5391H13.2526C12.5834 19.5391 12.041 20.0815 12.041 20.7506V22.5577C12.041 23.2269 12.5834 23.7693 13.2526 23.7693H30.433C31.1021 23.7693 31.6445 23.2269 31.6445 22.5577V20.7506C31.6445 20.0815 31.1021 19.5391 30.433 19.5391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.641 14.2065V15.8865C31.641 16.4965 31.2009 16.9965 30.6111 17.0865C30.551 17.0965 30.491 17.0965 30.431 17.0965H13.251C13.191 17.0965 13.131 17.0965 13.071 17.0865C12.481 16.9965 12.041 16.4965 12.041 15.8865V14.2065C12.041 12.5384 16.621 9.92139 21.841 9.92139C27.061 9.92139 31.641 12.581 31.641 14.2065Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.433 26.2139H13.2526C12.5834 26.2139 12.041 26.7563 12.041 27.4254V29.2325C12.041 29.9017 12.5834 30.4441 13.2526 30.4441H30.433C31.1021 30.4441 31.6445 29.9017 31.6445 29.2325V27.4254C31.6445 26.7563 31.1021 26.2139 30.433 26.2139Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2679_772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.3399,
    height: 48.9729,
    fill: "white",
    transform: "translate(0.671875 0.512695)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityStandpost);
export default __webpack_public_path__ + "static/media/community-standpost.18fd266271835c8f4d0dec5d7c00907f.svg";
export { ForwardRef as ReactComponent };